export default __webpack_public_path__ + "static/media/paragraph.acb95151.svg";